import { render, staticRenderFns } from "./SerialNumberHow.vue?vue&type=template&id=d0a9a180&scoped=true"
import script from "./SerialNumberHow.vue?vue&type=script&lang=js"
export * from "./SerialNumberHow.vue?vue&type=script&lang=js"
import style0 from "./SerialNumberHow.vue?vue&type=style&index=0&id=d0a9a180&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a9a180",
  null
  
)

export default component.exports